<div class="relative flex h-full">
  <!-- Toggle overlay: positioned absolutely over the editor/preview header (top-left) -->
  @if (showPreviewToggle()) {
    <div class="absolute left-3 top-2 z-[60]">
      <mat-button-toggle-group
        class="custom-toggle-group size-xs"
        hideSingleSelectionIndicator
        [value]="previewing() ? 'preview' : 'editor'"
        (change)="previewing.set($event.value === 'preview')"
      >
        <mat-button-toggle value="editor">
          <dojo-icon icon="pen-to-square" [size]="12" class="mr-1" />
          Editor
        </mat-button-toggle>
        <mat-button-toggle value="preview">
          <dojo-icon icon="eye" [size]="12" class="mr-1" />
          Preview
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  }

  <div #scrollableContainerRef class="h-full flex-1 overflow-auto">
    <!-- Editor: always mounted, hidden via CSS when previewing so the editor instance stays alive -->
    <dojo-tiptap-editor-wrapper
      #editorWrapper
      class="min-h-full"
      [class.hidden]="previewing()"
      [valueControl]="editorControl"
      [outputFormat]="TiptapEditorOutputFormat.Json"
      [editorOptions]="editorOptions()"
      [editable]="editable()"
      [slashMenuItems]="slashMenuItems"
      [scrollableParent]="scrollableContainer()"
      [contentPadding]="contentPadding()"
      [smartLinkConfig]="reactSmartLinkConfig()"
    />

    <!-- Preview mode -->
    @if (previewing()) {
      <!-- Sticky header background for the toggle buttons -->
      <div class="study-notes-preview-header sticky top-0 z-50 h-12"></div>

      <div
        #previewContentRef
        class="study-notes-preview"
        [style.padding]="contentPadding()"
        style="max-width: 768px; margin: 0 auto"
      >
        <dojo-content-blocks-renderer [blocks]="liveBlocks()" [defaultFormulaBookletUrl]="formulaBookletUrl()" />
      </div>
    }
  </div>

  @if (showTableOfContents()) {
    <div class="shrink-0 overflow-y-auto border-l border-neutral-200 p-3" style="width: 240px">
      <h3 class="mb-3 text-sm font-semibold text-neutral-700">Table of Content</h3>
      @if (!previewing() && editor(); as editor) {
        <dojo-tiptap-table-of-contents
          [tableOfContentData]="tableOfContentsData()"
          [editor]="editor"
          [scrollableParent]="scrollableContainer()"
        />
      } @else if (previewing()) {
        <dojo-content-block-toc
          [blocks]="liveBlocks()"
          [scrollableParent]="scrollableContainer()"
          [queryRoot]="previewContent()"
        />
      }
    </div>
  }
</div>
